import { axios, type ServerResponse } from '~/axios'

import { type ProjectsByOrganizationResponse } from '~/api'

export interface Project {
  id: number
  title: string
  description: string
  active: boolean
  color: string
}

export async function getProjectsPaginated({
  page,
  filter,
  organizations,
}: {
  page: number
  filter: string
  organizations: number[]
}) {
  interface SearchProjectsResponse {
    content: Project[]
    totalElements: number
    totalPages: number
  }

  const query = /* GraphQL */ `
    query SearchProjects($page: Int, $filter: String, $organizations: [Long]) {
      searchProjects(
        page: $page
        filter: $filter
        organizations: $organizations
      ) {
        content {
          id
          title
          description
          active
          color
        }
        totalElements
        totalPages
      }
    }
  `

  return await axios<
    ServerResponse<{ searchProjects: SearchProjectsResponse }>
  >({
    method: 'post',
    url: '/graphql',
    data: {
      query,
      variables: {
        page,
        filter,
        organizations,
      },
    },
  })
}

export async function getProjectsByOrgsAndHub(
  orgsId: number[],
  hubId?: number | null,
) {
  const query = /* GraphQL */ `
    query projectsByOrganization($organizations: [Long], $hub: Long) {
      projectsByOrganization(organizations: $organizations, hub: $hub) {
        id
        title
        description
        color
        active
      }
    }
  `

  return await axios<
    ServerResponse<{ projectsByOrganization: ProjectsByOrganizationResponse[] }>
  >({
    method: 'POST',
    url: '/graphql',
    data: {
      query,
      variables: {
        hub: hubId,
        organizations: orgsId,
      },
    },
  })
}
